import Product from "../../../../../@types/Product"
import assets from "../../../../../assets"

const FrontSeats: Product[] = [
    {
        id: 1,
        refId: 'BK01',
        name: 'Premium Black',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f94a96ed-8ff6-4795-8046-da84d29c8400',
        img: assets.images.seatSwatches.onyx,
    },
    {
        id: 2,
        refId: 'WH01',
        name: 'Premium Black',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f94a96ed-8ff6-4795-8046-da84d29c8400',
        img: assets.images.seatSwatches.onyx,
    },
    {
        id: 3,
        refId: 'BG09',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/81837308-0ca5-447d-4661-a29ae7eed100',
        img: assets.images.seatSwatches.caribbeanHoliday,
    },
    {
        id: 4,
        refId: 'GN07',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/d29ef93d-07d9-4abd-0942-c758dd056500',
        img: assets.images.seatSwatches.leafGreen,
    },
    {
        id: 5,
        refId: 'RD07',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/226b920b-f131-4bc7-68f2-e554515fdc00',
        img: assets.images.seatSwatches.chiliPepper,
    },
    {
        id: 6,
        refId: 'BL10',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/2380fef5-c11e-4540-a521-b366661aca00',
        img: assets.images.seatSwatches.ocean,
    },
]

const RearSeats: Product[] = [
    {
        id: 1,
        refId: 'BK01',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/fa3fc813-c9b6-4931-326f-ba43535ef300'
    },
    {
        id: 2,
        refId: 'WH01',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/fa3fc813-c9b6-4931-326f-ba43535ef300'
    },
    {
        id: 3,
        refId: 'BG09',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/fffa352e-0e79-49c0-8e6d-c46f5d857f00'
    },
    {
        id: 4,
        refId: 'GN07',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/763b3a20-4bc5-42bc-4a4d-bb212f4bf200'
    },
    {
        id: 5,
        refId: 'RD07',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/1f6337c4-ad35-4c89-557f-79b18bb3ee00'
    },
    {
        id: 6,
        refId: 'BL10',
        name: 'Premium Two-Tone',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/924d3336-1734-455e-143a-75f110774000'
    },
]

export { FrontSeats, RearSeats }